<template>
  <div>
    <h3 style="margin-bottom: 30px; margin-top: 25px">Loan Information</h3>
    <Input
      :inputField="inputs.justification"
      inputName="Provide a brief description of what your business does."
      inputType="string"
    />
    <Choices
      :inputField="inputs.loanuse"
      inputName="What will your business be using the loan for?"
      :options="[
        'Inventory',
        'Second Location',
        'Payroll',
        'Equipment Purchase',
        'Supplies',
        'Loan Consolidation',
      ]"
    />
    <div class="buttons is-right">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button" @click="next"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import ApplyPage from "@/components/shared/ApplyPage";
import Choices from "@/components/shared/Choices";
export default {
  name: "LoanInfo",
  components: {
    Input,
    Choices,
  },
  mixins: [ApplyPage],
  data() {
    return {
      obj: "loan",
      inputs: {
        justification: Input.model(),
        loanuse: Input.model(),
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
